// import logo from '../logo.svg';
// import '../App.css';
// import { Counter } from '../features/counter/Counter';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Wrapper from '../components/global/Wrapper';
import cacImage from '../assets/icons/DashboardIcons/cacIcon.svg';
import verifiedImage from '../assets/icons/DashboardIcons/verificationIcon.svg';
import QuickReminderCard from '../components/GetStartedPage/QuickReminderCard';
import QuickSetupCard from '../components/GetStartedPage/QuickSetupCard';
import CompletePaymentCard from '../components/GetStartedPage/CompletePaymentCard';
import axios, { AxiosError } from 'axios';
import { baseUrl_, timeout } from '../utils/constants';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { ClipLoader } from 'react-spinners';
import { decryptJson } from '../utils/decryptJson';
import payment_link from '../assets/icons/payment_link.svg';
import store_front from '../assets/icons/store_front.svg';
import bussAccount from '../assets/icons/bus_account.svg';
import addProduct from '../assets/icons/add_product.svg';
import { logUserOut } from '../utils/logUserOut';
import { fetchPackages } from '../utils/getPackageName';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { setAllPackages } from '../features/packages/packagesSlice';
import { TPendingPackages } from '../types';
import { hasARegistrationInLocalStorage } from '../utils/setRegInfoInLocalStorage';
import TwoFactorToggler from '../components/GetStartedPage/TwoFactorToggler';
import { Request } from '../apis/request';
import jwtDecode from 'jwt-decode';

const GetStartedPage = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 6000,
    arrows: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          // dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          // dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          // dots: false,
        },
      },
    ],
  };

  const [error, setError] = useState('');
  const [pendingPackages, setPendingPackages] = useState<TPendingPackages[]>([]);
  const stored2faEnabled = localStorage.getItem('2fa-enabled');
  const is2faEnabled = stored2faEnabled && JSON.parse(stored2faEnabled);
  const dispatch = useAppDispatch();

  const token: any = localStorage.getItem('login-token');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);
  const userDeets: any = jwtDecode(token);

  const { id } = details;
  const fetchUserInfo = async () => {
    try {
      const res = await Request.get(`/user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      });

      const surveyTriggered = JSON.parse(localStorage.getItem('qualtricsTriggered') || 'false');

      if (!surveyTriggered) {
        const surveyURL = `https://sterlingbank.eu.qualtrics.com/jfe/form/SV_40FSopjtulnbjzE?Q_CHL=si_appsdk&RecipientFirstName=${
          details?.firstName
        }&Phone_no=${details?.phoneNumber}&RecipientEmail=${encodeURIComponent(
          details?.email,
        )}&account_no=${userDeets?.accountNumber}&Gender=${details?.gender}&CustomerAge=${
          userDeets?.customerAge
        }&Location=${details?.country}`;

        setTimeout(() => {
          if (!surveyTriggered) {
            window.open(surveyURL, '_blank');
          }
        }, 500);

        localStorage.setItem('qualtricsTriggered', JSON.stringify(true)); // Store as boolean
      }
      return res;
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  const hasARegistrationInStorage: any = useMemo(() => {
    return hasARegistrationInLocalStorage();
  }, []);

  const gettingInfo = useQuery('user-info', fetchUserInfo, {
    onSuccess: (data: any) => {
      const res = decryptJson(data?.data?.data);
      const busReg: TPendingPackages[] = res?.businessRegistration;
      const arr: TPendingPackages[] = [];
      if (typeof busReg === 'object') {
        for (let i = 0; i < busReg.length; i++) {
          if (busReg[i]?.paid === false) {
            arr.push(busReg[i]);
          }
        }
        setPendingPackages(arr);
      }
    },
    onError: (error: AxiosError<{ message: string; status?: number }>) => {
      // handleError({ error, errorFn });
      if (error?.response?.data?.status === 593) {
        logUserOut(error?.response?.data?.status);
      } else {
        setError(error?.response?.data?.message ?? '');
      }
    },
  });

  const fetchingPackagesQuery = useQuery('business-packages', fetchPackages, {
    onSuccess: (data) => {
      const res = decryptJson(data?.data?.data);
      dispatch(setAllPackages(res));
    },
    onError: (error: AxiosError<{ message: string; status?: number }>) => {
      if (error?.response?.data?.status === 593) {
        logUserOut(error?.response?.data?.status);
      } else {
        setError(error?.response?.data?.message ?? '');
      }
    },
  });

  return (
    <>
      <Wrapper className=' space-y-3 pt-[30px] mt-[100px] md:pt-12 md:space-y-8  !mr-0'>
        {/* <div className='hidden border-b-[1px] md:block md:mt-12  border-[#CDD5D5]'></div> */}
        {error ? (
          <div className='flex justify-center'>
            <b className='text-[red] text-[14px]'>{error}</b>
          </div>
        ) : (
          !error &&
          (gettingInfo?.isLoading || fetchingPackagesQuery?.isLoading ? (
            <div className='flex justify-center '>
              <ClipLoader
                color={'#F8B400'}
                loading={gettingInfo?.isLoading || fetchingPackagesQuery?.isLoading}
                size={50}
              />
            </div>
          ) : (
            <>
              <div className='md:ml-[30px]'>
                <div>
                  <div className='flex justify-end  lg:mr-[60px]'>
                    <div className='bg-[#A6B0BE36] px-[27px] flex  justify-between items-center  h-[51px] w-[261px] rounded-[100px]'>
                      {!is2faEnabled ? (
                        <div>
                          <h3 className='text-[#F51010] font-Poppins font-medium text-[16px] '>
                            2fa is disabled.
                          </h3>
                          <h3 className='text-[#000] font-Poppins font-normal text-[15.228px] '>
                            Enable 2FA?
                          </h3>
                        </div>
                      ) : (
                        <>
                          <div>
                            <h3 className='text-green font-Poppins font-medium text-[16px] '>
                              2FA is enabled.
                            </h3>
                            <h3 className='text-[#000] font-Poppins font-normal text-[15.228px] '>
                              Disable 2FA?
                            </h3>
                          </div>
                        </>
                      )}
                      <TwoFactorToggler is2faEnabled={is2faEnabled} />
                    </div>
                  </div>
                  {(pendingPackages?.length > 0 || hasARegistrationInStorage) && (
                    <CompletePaymentCard />
                  )}
                  {/* {pendingPackages?.length > 0 && (
                    <CompletePaymentCard
                      pendingReg={pendingPackages}
                      className='mb-[27px] mt-[20px]'
                    />
                  )} */}

                  <div className='flex justify-between items-center'>
                    <h3 className='text-green font-poppins font-semibold  pb-[30px] text-lg'>
                      Quick reminder!
                    </h3>
                  </div>
                  <div className='lg:flex lg:flex-row lg:gap-[60px]'>
                    <QuickReminderCard
                      className='h-[208px]'
                      icon={cacImage}
                      title='Register Your Business!'
                      desc='Get your CAC Registration - Business name or Limited Liability Company (LLC) done in a few days.'
                      btnText='GET STARTED'
                    />

                    <QuickReminderCard
                      icon={verifiedImage}
                      title='Update Your profile'
                      desc='Verify your account to start receiving payments.'
                      btnText='UPDATE PROFILE'
                      className='!bg-[#f8b40033]  h-[208px]'
                    />
                  </div>
                </div>
              </div>
              <div className=' mt-5 md:mt-[auto] border-b-[1px]   border-[#CDD5D5]'></div>
              <div className='hidden md:block md:ml-[30px]'>
                <h3 className='text-black font-poppins font-semibold  pb-[30px] text-lg'>
                  Quick Set up!
                </h3>
                <div className='flex flex-row flex-wrap gap-5'>
                  <QuickSetupCard
                    title='Payment Links'
                    desc='Create payment links to start accepting payments.'
                    icon={payment_link}
                    btnText='Coming soon'
                  />
                  <QuickSetupCard
                    title='Set up Store Front'
                    desc='Create your store front and share on your socials.'
                    icon={store_front}
                    btnText='Coming soon'
                  />
                  <QuickSetupCard
                    title='Add products'
                    desc='Design your product catalogue on your store front.'
                    icon={addProduct}
                    btnText='Coming soon'
                  />
                  <QuickSetupCard
                    title='Create Business Account'
                    desc='Enter your bank details to receive money into your account.'
                    icon={bussAccount}
                    btnText='Coming soon'
                  />
                  {/*<QuickSetupCard
              title='Setup Store Front'
              desc='Set up your store front and share with friends and family.'
              icon={storeImage}
              btnText='Set up store'
              /> */}
                </div>
              </div>
              <div className='block md:hidden'>
                <h3 className='text-green font-poppins font-semibold  py-[30px] text-lg'>
                  Quick setup!
                </h3>

                <Slider {...settings}>
                  <QuickSetupCard
                    title='Payment Links'
                    desc='Create payment links to start accepting payments.'
                    icon={payment_link}
                    btnText='Coming soon'
                  />
                  <QuickSetupCard
                    title='Setup Store Front'
                    desc='Set up your store front and share with friends and family.'
                    icon={store_front}
                    btnText='Coming soon'
                  />
                  <QuickSetupCard
                    title='Add product'
                    desc='Create your product catalogue on your store front'
                    icon={addProduct}
                    btnText='Coming soon'
                  />

                  <QuickSetupCard
                    title='Add bank details'
                    desc='Set up your bank details to recieve money into your back account'
                    icon={bussAccount}
                    btnText='Coming soon'
                  />

                  <QuickSetupCard
                    title='Setup Store Front'
                    desc='Set up your store front and share with friends and family.'
                    icon={store_front}
                    btnText='Coming soon'
                  />
                </Slider>
              </div>
            </>
          ))
        )}
      </Wrapper>
    </>
  );
};

export default GetStartedPage;
